import styled from 'styled-components'
import { VARIABLES } from 'themes'

// Modifier (props)
// ============================================================

// Core
// ============================================================
export const SpinnerStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  border-radius: 5px;
  /* background-color: white; */
  justify-content: center;
  padding: 20px 0;

  /* Child element styles
  ------------------------------- */

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */
  &.loading {
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: ${VARIABLES.Z_INDEXS.LV_8};
    align-items: center;
    justify-content: center;
    /* background-color: ${VARIABLES.COLORS.OVERLAY_1}; */
  }

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
